import { SUPPLIERS_UI_STYLES } from "./suppliersUi";

export const ITEMS_FAMILIES_UI_STYLES = `
  ${SUPPLIERS_UI_STYLES}

  .ifm-page {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 12px;
    min-height: 0;
  }

  .ifm-tabBar {
    display: flex;
    align-items: center;
    min-height: 0;
    padding: 2px 0 0;
  }

  .ifm-tabRow {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  .ifm-tab {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 38px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(217, 229, 247, 0.8);
    padding: 8px 14px;
    font-size: 0.78rem;
    font-weight: 800;
    cursor: pointer;
    transition: transform 120ms ease, border-color 120ms ease, background 120ms ease, box-shadow 120ms ease;
  }

  .ifm-tab:hover {
    transform: translateY(-1px);
  }

  .ifm-tab--active {
    border-color: rgba(34, 211, 238, 0.58);
    background: rgba(34, 211, 238, 0.16);
    color: rgba(214, 251, 255, 0.95);
    box-shadow: 0 0 0 2px rgba(34, 211, 238, 0.09);
  }

  .ifm-tabCount {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 7px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.1);
    color: rgba(237, 243, 255, 0.88);
    font-size: 0.7rem;
    font-weight: 900;
  }

  .ifm-toolbarGrid {
    display: grid;
    gap: 12px;
    align-items: center;
  }

  .ifm-toolbarGrid--two {
    grid-template-columns: minmax(260px, 1.35fr) minmax(220px, 0.65fr);
  }

  .ifm-toolbarGrid--three {
    grid-template-columns: minmax(260px, 1.3fr) repeat(2, minmax(180px, 0.5fr));
  }

  .ifm-table--items {
    min-width: 1940px;
  }

  .ifm-table--compact {
    min-width: 1080px;
  }

  .ifm-table--medium {
    min-width: 1260px;
  }

  .ifm-stack {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .ifm-mini {
    color: rgba(206, 219, 243, 0.64);
    font-size: 0.73rem;
    line-height: 1.42;
  }

  .ifm-tagRow {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .ifm-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(229, 238, 252, 0.82);
    padding: 5px 9px;
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .ifm-tag--accent {
    border-color: rgba(34, 211, 238, 0.34);
    background: rgba(34, 211, 238, 0.1);
    color: rgba(214, 251, 255, 0.92);
  }

  .ifm-taxonomyLink {
    display: inline;
    max-width: 100%;
    border: 0;
    background: transparent;
    color: rgba(201, 220, 246, 0.82);
    padding: 0;
    font: inherit;
    line-height: inherit;
    text-align: left;
    text-decoration: underline;
    text-decoration-color: rgba(99, 215, 255, 0.38);
    text-underline-offset: 3px;
    cursor: pointer;
  }

  .ifm-taxonomyLink:hover,
  .ifm-taxonomyLink:focus-visible {
    color: rgba(147, 232, 255, 0.98);
    text-decoration-color: rgba(99, 215, 255, 0.9);
    outline: none;
  }

  .ifm-taxonomyLink--strong {
    color: rgba(244, 248, 255, 0.96);
    font-weight: 800;
  }

  .ifm-taxonomyLink.ifm-tag {
    display: inline-flex;
    text-decoration: none;
  }

  .ifm-modalToolbar {
    display: grid;
    grid-template-columns: minmax(260px, 1fr) auto;
    gap: 12px;
    align-items: center;
  }

  .ifm-taxonomyItemsTable {
    min-width: 900px;
  }

  .ifm-policyCell {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 180px;
  }

  .ifm-policySelect {
    width: 100%;
    min-width: 178px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(240, 245, 255, 0.92);
    padding: 8px 10px;
    font-size: 0.78rem;
    font-weight: 800;
    outline: none;
  }

  .ifm-policySelect option {
    background: #ffffff;
    color: #07131e;
  }

  .ifm-policyBadge {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    max-width: 100%;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(229, 238, 252, 0.84);
    padding: 5px 9px;
    font-size: 0.7rem;
    font-weight: 900;
    line-height: 1.2;
  }

  .ifm-policyBadge--stockable {
    border-color: rgba(34, 211, 238, 0.32);
    background: rgba(34, 211, 238, 0.1);
    color: rgba(210, 247, 255, 0.94);
  }

  .ifm-policyBadge--direct {
    border-color: rgba(251, 191, 36, 0.38);
    background: rgba(251, 191, 36, 0.12);
    color: rgba(255, 237, 190, 0.96);
  }

  .ifm-tokenList {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    min-height: 58px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.03);
    padding: 10px 12px;
  }

  .ifm-token {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-radius: 999px;
    border: 1px solid rgba(34, 211, 238, 0.36);
    background: rgba(34, 211, 238, 0.12);
    color: rgba(220, 249, 255, 0.96);
    padding: 7px 10px;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .ifm-tokenRemove {
    border: 0;
    background: transparent;
    color: rgba(255, 203, 203, 0.92);
    font-size: 0.95rem;
    line-height: 1;
    padding: 0;
    cursor: pointer;
  }

  .ifm-fieldHint {
    color: rgba(204, 217, 241, 0.62);
    font-size: 0.73rem;
    line-height: 1.45;
  }

  .ifm-noteAccent {
    color: rgba(137, 231, 255, 0.84);
    font-weight: 800;
  }

  .ifm-emptyState {
    padding: 16px 18px;
    border-radius: 16px;
    border: 1px dashed rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.02);
    color: rgba(206, 219, 243, 0.68);
    text-align: center;
    font-size: 0.85rem;
  }

  .ifm-previewNote {
    color: rgba(206, 219, 243, 0.66);
    font-size: 0.78rem;
    line-height: 1.45;
  }

  @media (max-width: 920px) {
    .ifm-toolbarGrid--two,
    .ifm-toolbarGrid--three,
    .ifm-modalToolbar {
      grid-template-columns: 1fr;
    }
  }
`;

export function readItemsFamiliesUser() {
  try {
    return JSON.parse(localStorage.getItem("palantir_user")) || null;
  } catch (error) {
    return null;
  }
}

export function formatItemsFamiliesDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export function truncateItemsFamiliesText(value, maxLength = 56) {
  const text = String(value || "-");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(0, maxLength - 3)).trimEnd()}...`;
}

export function buildSearchBlob(values) {
  return (values || [])
    .filter(Boolean)
    .map((value) => String(value).toLowerCase())
    .join(" ");
}

export function normalizeImportPreviewRows(rows) {
  return (rows || []).filter((row) =>
    Object.values(row || {}).some((value) => String(value ?? "").trim() !== "")
  );
}

export function getItemHierarchy(item) {
  return {
    family:
      item?.subcategory?.category?.subfamily?.family?.name ||
      item?.category?.subfamily?.family?.name ||
      "-",
    subfamily:
      item?.subcategory?.category?.subfamily?.name ||
      item?.category?.subfamily?.name ||
      "-",
    category: item?.subcategory?.category?.name || item?.category?.name || "-",
    subcategory: item?.subcategory?.name || "-",
  };
}

export function getItemCategoryOptions(items, familyFilter = "all") {
  const selectedFamily = String(familyFilter || "all");

  return Array.from(
    new Set(
      (items || [])
        .map((item) => getItemHierarchy(item))
        .filter(
          (hierarchy) =>
            selectedFamily === "all" || hierarchy.family === selectedFamily
        )
        .map((hierarchy) => hierarchy.category)
        .filter((value) => value && value !== "-")
    )
  ).sort((left, right) =>
    left.localeCompare(right, undefined, { sensitivity: "base" })
  );
}

export function getItemSupplierNames(item) {
  return (item?.item_suppliers || [])
    .map((link) => link?.supplier?.name)
    .filter(Boolean);
}

export const INVENTORY_POLICY = {
  STOCKABLE: "stockable",
  DIRECT_CONSUMPTION: "direct_consumption",
};

export const INVENTORY_POLICY_SELECT_OPTIONS = [
  { value: "", label: "Inherit / Default stockable" },
  { value: INVENTORY_POLICY.STOCKABLE, label: "Stockable" },
  { value: INVENTORY_POLICY.DIRECT_CONSUMPTION, label: "Direct Consumption" },
];

function titleCasePolicyLevel(level) {
  const normalized = String(level || "").replace(/_/g, " ");
  return normalized ? normalized.charAt(0).toUpperCase() + normalized.slice(1) : "Default";
}

export function normalizeInventoryPolicy(value) {
  const policy = String(value || "").trim().toLowerCase();
  if (policy === INVENTORY_POLICY.DIRECT_CONSUMPTION) return INVENTORY_POLICY.DIRECT_CONSUMPTION;
  if (policy === INVENTORY_POLICY.STOCKABLE) return INVENTORY_POLICY.STOCKABLE;
  return "";
}

export function inventoryPolicyLabel(policy) {
  return normalizeInventoryPolicy(policy) === INVENTORY_POLICY.DIRECT_CONSUMPTION
    ? "Direct Consumption"
    : "Stockable";
}

export function inventoryPolicyBadgeClass(policy) {
  return normalizeInventoryPolicy(policy) === INVENTORY_POLICY.DIRECT_CONSUMPTION
    ? "ifm-policyBadge ifm-policyBadge--direct"
    : "ifm-policyBadge ifm-policyBadge--stockable";
}

function policySource(level, node) {
  const policy = normalizeInventoryPolicy(node?.inventory_policy);
  return policy ? { policy, sourceLevel: level, sourceName: node?.name || null } : null;
}

export function resolveTaxonomyInventoryPolicy(node, level) {
  if (level === "family") {
    const explicit = policySource("family", node);
    return explicit || { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null };
  }

  if (level === "subfamily") {
    return (
      policySource("subfamily", node) ||
      policySource("family", node?.family) ||
      { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null }
    );
  }

  if (level === "category") {
    return (
      policySource("category", node) ||
      policySource("subfamily", node?.subfamily) ||
      policySource("family", node?.subfamily?.family) ||
      { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null }
    );
  }

  return (
    policySource("subcategory", node) ||
    policySource("category", node?.category) ||
    policySource("subfamily", node?.category?.subfamily) ||
    policySource("family", node?.category?.subfamily?.family) ||
    { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null }
  );
}

export function resolveTaxonomyInheritedInventoryPolicy(node, level) {
  if (level === "family") {
    return { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null };
  }

  if (level === "subfamily") {
    return (
      policySource("family", node?.family) ||
      { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null }
    );
  }

  if (level === "category") {
    return (
      policySource("subfamily", node?.subfamily) ||
      policySource("family", node?.subfamily?.family) ||
      { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null }
    );
  }

  return (
    policySource("category", node?.category) ||
    policySource("subfamily", node?.category?.subfamily) ||
    policySource("family", node?.category?.subfamily?.family) ||
    { policy: INVENTORY_POLICY.STOCKABLE, sourceLevel: "default", sourceName: null }
  );
}

export function inventoryPolicySelectOptionsFor(node, level) {
  const inherited = resolveTaxonomyInheritedInventoryPolicy(node, level);
  const inheritLabel =
    level === "family"
      ? "Default (Stockable)"
      : `Inherit (${inventoryPolicyLabel(inherited.policy)})`;

  return [
    { value: "", label: inheritLabel },
    { value: INVENTORY_POLICY.STOCKABLE, label: "Stockable" },
    { value: INVENTORY_POLICY.DIRECT_CONSUMPTION, label: "Direct Consumption" },
  ];
}

export function resolveItemInheritedInventoryPolicy(item) {
  const category = item?.subcategory?.category || item?.category;
  if (item?.subcategory) {
    return resolveTaxonomyInventoryPolicy(
      {
        ...item.subcategory,
        category,
      },
      "subcategory"
    );
  }

  return resolveTaxonomyInventoryPolicy(category, "category");
}

export function inventoryPolicySelectOptionsForItem(item) {
  const inherited = resolveItemInheritedInventoryPolicy(item);
  return [
    { value: "", label: `Inherit (${inventoryPolicyLabel(inherited.policy)})` },
    { value: INVENTORY_POLICY.STOCKABLE, label: "Stockable" },
    { value: INVENTORY_POLICY.DIRECT_CONSUMPTION, label: "Direct Consumption" },
  ];
}

export function getItemInventoryPolicy(item) {
  if (item?.inventory_policy_effective) {
    return {
      policy: normalizeInventoryPolicy(item.inventory_policy_effective) || INVENTORY_POLICY.STOCKABLE,
      sourceLevel: item.inventory_policy_source_level || "default",
      sourceName: item.inventory_policy_source_name || null,
    };
  }

  const explicitPolicy = normalizeInventoryPolicy(item?.inventory_policy);
  if (explicitPolicy) {
    return {
      policy: explicitPolicy,
      sourceLevel: "item",
      sourceName: item?.name || null,
    };
  }

  return resolveItemInheritedInventoryPolicy(item);
}

export function isDirectConsumptionItem(item) {
  return getItemInventoryPolicy(item).policy === INVENTORY_POLICY.DIRECT_CONSUMPTION;
}

export function inventoryPolicyHint(resolvedPolicy, currentLevel) {
  if (!resolvedPolicy || resolvedPolicy.sourceLevel === "default") return "Default: Stockable";

  const sourceLabel = titleCasePolicyLevel(resolvedPolicy.sourceLevel);
  const sourceName = resolvedPolicy.sourceName ? `: ${resolvedPolicy.sourceName}` : "";
  if (currentLevel && resolvedPolicy.sourceLevel !== currentLevel) {
    return `Inherited from ${sourceLabel}${sourceName}`;
  }

  return `Set on ${sourceLabel}${sourceName}`;
}
